export default class CollapsedListOptions {
  list: string[];
  maxCollapsedListLength: number;
  collapsibleLinkStringKey: string;
  noItemsStringKey: string;

  constructor(list: string[]) {
    this.list = list;
    this.maxCollapsedListLength = 3;
    this.collapsibleLinkStringKey = 'RequestListCollapsibleLink';
    this.noItemsStringKey = 'CollapsibleListNoRecipients';
  }
}